export default {

  users: [],
  user: {},
  roles: [],
  bannedUser: [],
  customers: [],
  blockCustomers: [],
  permissions: [],

  employees: [],
  deletedEmployees: [],
  employee: {},

  persons: [],
  person: {},
  OrdersUser :[],

};
